module.exports = __webpack_public_path__ + "img/baiti_yuanlin.26017c4d.png";